require("core-js/modules/esnext.global-this.js");

!function (e, r) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = r(require("react"), require("prop-types"), require("@leafygreen-ui/emotion")) : "function" == typeof define && define.amd ? define(["react", "prop-types", "@leafygreen-ui/emotion"], r) : ((e = "undefined" != typeof globalThis ? globalThis : e || self).ArrowRight = e.ArrowRight || {}, e.ArrowRight.js = r(e.React, e.PropTypes, e["@leafygreen-ui/emotion"]));
}(this, function (e, r, t) {
  "use strict";

  function l(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  function a(e) {
    if (e && e.__esModule) return e;
    var r = Object.create(null);
    return e && Object.keys(e).forEach(function (t) {
      if ("default" !== t) {
        var l = Object.getOwnPropertyDescriptor(e, t);
        Object.defineProperty(r, t, l.get ? l : {
          enumerable: !0,
          get: function get() {
            return e[t];
          }
        });
      }
    }), r.default = e, Object.freeze(r);
  }

  var n = a(e),
      i = l(r);

  function o(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[r] = t, e;
  }

  function u() {
    return u = Object.assign || function (e) {
      for (var r = 1; r < arguments.length; r++) {
        var t = arguments[r];

        for (var l in t) {
          Object.prototype.hasOwnProperty.call(t, l) && (e[l] = t[l]);
        }
      }

      return e;
    }, u.apply(this, arguments);
  }

  function f(e, r) {
    if (null == e) return {};

    var t,
        l,
        a = function (e, r) {
      if (null == e) return {};
      var t,
          l,
          a = {},
          n = Object.keys(e);

      for (l = 0; l < n.length; l++) {
        t = n[l], r.indexOf(t) >= 0 || (a[t] = e[t]);
      }

      return a;
    }(e, r);

    if (Object.getOwnPropertySymbols) {
      var n = Object.getOwnPropertySymbols(e);

      for (l = 0; l < n.length; l++) {
        t = n[l], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
      }
    }

    return a;
  }

  function c(e, r) {
    return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
      raw: {
        value: Object.freeze(r)
      }
    }));
  }

  var s,
      b,
      p = {
    small: 14,
    default: 16,
    large: 20,
    xlarge: 24
  };

  var d = ["className", "size", "title", "aria-label", "aria-labelledby", "fill", "role"],
      y = function y(e) {
    var r,
        l = e.className,
        a = e.size,
        i = void 0 === a ? 16 : a,
        y = e.title,
        g = e["aria-label"],
        m = e["aria-labelledby"],
        h = e.fill,
        O = e.role,
        v = void 0 === O ? "img" : O,
        j = f(e, d),
        w = t.css(s || (s = c(["\n    color: ", ";\n  "])), h),
        L = t.css(b || (b = c(["\n    flex-shrink: 0;\n  "]))),
        C = function (e, r, t) {
      var l,
          a,
          n = t["aria-label"],
          i = t["aria-labelledby"],
          u = t.title;

      switch (e) {
        case "img":
          return n || i || u ? (o(l = {}, "aria-labelledby", i), o(l, "aria-label", n), o(l, "title", u), l) : {
            "aria-label": (a = r, "".concat(a.replace(/([a-z])([A-Z])/g, "$1 $2"), " Icon"))
          };

        case "presentation":
          return {
            "aria-hidden": !0,
            alt: ""
          };
      }
    }(v, "ArrowRight", (o(r = {
      title: y
    }, "aria-label", g), o(r, "aria-labelledby", m), r));

    return n.createElement("svg", u({
      className: t.cx(o({}, w, null != h), L, l),
      height: "number" == typeof i ? i : p[i],
      width: "number" == typeof i ? i : p[i],
      role: v
    }, C, j, {
      viewBox: "0 0 16 16"
    }), n.createElement("path", {
      d: "M3 6.83212L9.94442 6.83212L8.40941 5.29711C8.01888 4.90659 8.01889 4.27342 8.40941 3.8829L8.64833 3.64398C9.03885 3.25346 9.67201 3.25345 10.0625 3.64398L13.4452 7.02661C13.4544 7.03518 13.4635 7.04395 13.4725 7.05292L13.7114 7.29184C14.1019 7.68237 14.1019 8.31553 13.7114 8.70605L10.0602 12.3572C9.66972 12.7477 9.03656 12.7477 8.64603 12.3572L8.40712 12.1183C8.01659 11.7278 8.01659 11.0946 8.40712 10.7041L9.9412 9.17L3 9.17C2.44771 9.17 2 8.72228 2 8.17L2 7.83212C2 7.27983 2.44772 6.83212 3 6.83212Z",
      fill: "currentColor"
    }));
  };

  return y.displayName = "ArrowRight", y.isGlyph = !0, y.propTypes = {
    fill: i.default.string,
    size: i.default.oneOfType([i.default.number, i.default.string]),
    className: i.default.string
  }, y;
});